import { Search as SearchComponent } from '../../../components/Search';

export function Search() {
  return <SearchComponent />;
}
